import type { PaletteOptions } from '@mui/material/styles';

/**
 * Dark is the product default. The ground is a near-black with a slight blue-green cast rather than pure
 * #000, so elevation reads as a lift instead of a glow, and the green carries over from the light theme so
 * the two are recognisably the same product.
 */
export const DARK_PALETTE: PaletteOptions = {
  mode: 'dark',
  primary: { main: '#5fb98a', light: '#87d0a8', dark: '#3d8f65', contrastText: '#0b0e10' },
  secondary: { main: '#e0a458', light: '#eec084', dark: '#b07f3c', contrastText: '#0b0e10' },
  success: { main: '#5fb98a' },
  warning: { main: '#e0a458' },
  error: { main: '#e5716b' },
  info: { main: '#6aa8d8' },
  background: { default: '#0f1215', paper: '#161a1e' },
  divider: 'rgba(255, 255, 255, 0.09)',
  text: { primary: '#e4ebf1', secondary: '#93a1ae', disabled: '#5d6a76' },
  action: {
    hover: 'rgba(255, 255, 255, 0.045)',
    selected: 'rgba(95, 185, 138, 0.14)',
    disabled: 'rgba(255, 255, 255, 0.26)',
    disabledBackground: 'rgba(255, 255, 255, 0.09)',
  },
};

export const LIGHT_PALETTE: PaletteOptions = {
  mode: 'light',
  primary: { main: '#2f6f4f', light: '#4f9070', dark: '#1f4d35', contrastText: '#ffffff' },
  secondary: { main: '#b3762a', light: '#cf9750', dark: '#8a5a1d', contrastText: '#ffffff' },
  success: { main: '#2f7d4f' },
  warning: { main: '#b7791f' },
  error: { main: '#b3413b' },
  info: { main: '#2f6a99' },
  background: { default: '#f5f7f6', paper: '#ffffff' },
  divider: 'rgba(15, 18, 21, 0.10)',
  text: { primary: '#171c20', secondary: '#5b6770', disabled: '#98a3ab' },
};

/** Categorical series colours for charts, ordered so neighbours stay distinguishable. */
export const CHART_SERIES: Array<string> = ['#5fb98a', '#6aa8d8', '#e0a458', '#b28fd0', '#e5716b'];
